import { Banner, FeatureProperties, Steps } from './components';
import './Dashboard.scss';

const Dasboard = () => {
  return (
    <div className="dashboard">
      <div className="dashboard__left">
        <h2 className="title">Dashboard</h2>
        <Banner />
        <FeatureProperties />
      </div>
      <div className="dashboard__right">
        <Steps />
      </div>
    </div>
  );
};

export default Dasboard;
